/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Progress_Totals_RecordsInputs */

const en_us2_progress_totals_records = /** @type {(inputs: Progress_Totals_RecordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Records this month`)
};

const pt_br2_progress_totals_records = /** @type {(inputs: Progress_Totals_RecordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recordes no mês`)
};

const es_419_progress_totals_records = /** @type {(inputs: Progress_Totals_RecordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Récords del mes`)
};

const pt_pt2_progress_totals_records = /** @type {(inputs: Progress_Totals_RecordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recordes no mês`)
};

const fr_fr2_progress_totals_records = /** @type {(inputs: Progress_Totals_RecordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Records ce mois-ci`)
};

const de_de2_progress_totals_records = /** @type {(inputs: Progress_Totals_RecordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rekorde diesen Monat`)
};

const it_it2_progress_totals_records = /** @type {(inputs: Progress_Totals_RecordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Record nel mese`)
};

/**
* | output |
* | --- |
* | "Records this month" |
*
* @param {Progress_Totals_RecordsInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const progress_totals_records = /** @type {((inputs?: Progress_Totals_RecordsInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Progress_Totals_RecordsInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_progress_totals_records(inputs)
	if (locale === "es-419") return es_419_progress_totals_records(inputs)
	if (locale === "pt-PT") return pt_pt2_progress_totals_records(inputs)
	if (locale === "fr-FR") return fr_fr2_progress_totals_records(inputs)
	if (locale === "de-DE") return de_de2_progress_totals_records(inputs)
	if (locale === "it-IT") return it_it2_progress_totals_records(inputs)
	return en_us2_progress_totals_records(inputs)
});
export { progress_totals_records as "progress.totals_records" }